
const defaultValidationMessages = {
  required: '* required',
  invalidDays: 'The date must be at least 30 days from today',
  maxLength: 'character limit exceeded',
  zipMaxLength: 'Cannot exceed 9 Digits',
  zipMinLength: '5 Or 9 Digits Long',
  phoneMinLength: '10 Digits Long',
  phoneMaxLength: 'Cannot exceed 10 Digits',
  invalid: 'invalid information',
  numeric: 'numeric characters only',
  alphaNumeric: 'alphanumeric characters only',
  email: 'invalid email format',
  minDate: 'minimum 30 days from today',
  minTime: 'must be 7am or later',
  maxTime: 'must be 7pm or earlier',
  weekday: 'must select a weekday',
  minEventDuration: 'must be at least an hour',
  maxEventDuration: 'must be 8 hours or less',
  minDeliverPeriod: 'must allow enough time to deliver',
  minDigitalPeriod: 'must allow at least 3 days to deliver',
  minPrintedPeriod: 'must allow at least 10 days to deliver',
  eventDateAlreadyTaken: 'event date already taken',
  packetQuantity: 'cannot exceed eligible employees',
  generic: 'You have not met the needed requirements.',
  locationNameAlreadyTaken: 'Location name already taken',
  locationNameLength: '30 Character Limit Exceeded',
  nameAlphaNumeric: 'Special Characters Not Permitted',
  minMaxValue: 'must be between 1 to 3,000,000',
  totalEmp: 'cannot exceed total employees at company',
  totalEmpAtLocation: 'cannot exceed total employees at location',
  min: 'must be at least 1'
}

function hasPropertyAndIsInvalid(item, property) {
  return item[property] !== undefined && item[property] === false
}

export function validationMessage(item, messages) {
  messages = !messages ? defaultValidationMessages : messages

  if (!item.$model) {
    return messages.required
  } else if (item.$invalid) {
    if (hasPropertyAndIsInvalid(item, 'zipMinLength')) return messages.zipMinLength
    else if (hasPropertyAndIsInvalid(item, 'zipMaxLength')) return messages.zipMaxLength
    else if (hasPropertyAndIsInvalid(item, 'maxLength')) return messages.maxLength
    else if (hasPropertyAndIsInvalid(item, 'packetQuantity')) return messages.packetQuantity
    else if (hasPropertyAndIsInvalid(item, 'invalidDays')) return messages.invalidDays
    else if (hasPropertyAndIsInvalid(item, 'weekday')) return messages.weekday
    else if (hasPropertyAndIsInvalid(item, 'numeric')) return messages.numeric
    else if (hasPropertyAndIsInvalid(item, 'phoneMinLength')) return messages.phoneMinLength
    else if (hasPropertyAndIsInvalid(item, 'phoneMaxLength')) return messages.phoneMaxLength
    else if (hasPropertyAndIsInvalid(item, 'locationNameAlreadyTaken')) return messages.locationNameAlreadyTaken
    else if (hasPropertyAndIsInvalid(item, 'locationNameLength')) return messages.locationNameLength
    else if (hasPropertyAndIsInvalid(item, 'nameAlphaNumeric')) return messages.nameAlphaNumeric
    else if (hasPropertyAndIsInvalid(item, 'alphaNumeric')) return messages.alphaNumeric
    else if (hasPropertyAndIsInvalid(item, 'email')) return messages.email
    else if (hasPropertyAndIsInvalid(item, 'minDate')) return messages.minDate
    else if (hasPropertyAndIsInvalid(item, 'minEndTime')) return messages.minEventDuration
    else if (hasPropertyAndIsInvalid(item, 'minTime')) return messages.minTime
    else if (hasPropertyAndIsInvalid(item, 'maxTime')) return messages.maxTime
    else if (hasPropertyAndIsInvalid(item, 'maxEventDuration')) return messages.maxEventDuration
    else if (hasPropertyAndIsInvalid(item, 'minEventDuration')) return messages.minEventDuration
    else if (hasPropertyAndIsInvalid(item, 'minDeliverPeriod')) return messages.minDeliverPeriod
    else if (hasPropertyAndIsInvalid(item, 'minDigitalPeriod')) return messages.minDigitalPeriod
    else if (hasPropertyAndIsInvalid(item, 'minPrintedPeriod')) return messages.minPrintedPeriod
    else if (hasPropertyAndIsInvalid(item, 'eventDateAlreadyTaken')) return messages.eventDateAlreadyTaken
    else if (hasPropertyAndIsInvalid(item, 'minMaxValue')) return messages.minMaxValue
    else if (hasPropertyAndIsInvalid(item, 'totalEmp')) return messages.totalEmp
    else if (hasPropertyAndIsInvalid(item, 'totalEmpAtLocation')) return messages.totalEmpAtLocation
    else if (hasPropertyAndIsInvalid(item, 'min')) return messages.min
    else if (item.$error) return messages.required
    else if (item.required) return messages.required
    else if (item.invalid) return messages.invalid
    else return messages.generic
  } else {
    return messages.required
  }
}
